import React from 'react';
import {
  db_front_foot_elevated_split_squat,
  dowel_standing_shoulder_press,
  ng_shoulder_width_lat_pull_down,
  dowel_standing_hip_hinge,
  dowel_bodyweight_squat
} from 'utils/constants/assessments';
import MovementBlocK from './MovementBlock';
import SectionTitle from './SectionTitle';

const MovementSection = ({ assessment }) => {
  return (
    <div className="template-section">
      <SectionTitle title="Functional Movement Screening" />
      <div className="movement-list">
        <div>
          <MovementBlocK
            movementMapping={dowel_bodyweight_squat}
            movement={assessment.dowel_bodyweight_squat}
          />
          <MovementBlocK
            movementMapping={dowel_standing_hip_hinge}
            movement={assessment.dowel_standing_hip_hinge}
          />
          <MovementBlocK
            movementMapping={ng_shoulder_width_lat_pull_down}
            movement={assessment.ng_shoulder_width_lat_pull_down}
          />
        </div>
        <div>
          <MovementBlocK
            movementMapping={dowel_standing_shoulder_press}
            movement={assessment.dowel_standing_shoulder_press}
          />
          <MovementBlocK
            movementMapping={db_front_foot_elevated_split_squat}
            movement={assessment.db_front_foot_elevated_split_squat}
          />
        </div>
      </div>
    </div>
  );
};

export default MovementSection;
